import React, { useEffect } from "react";
import styled from "styled-components";

const Success = () => {
  useEffect(() => {
    return () => {
      localStorage.clear();
    };
  }, []);
  const order_id = localStorage.getItem("litewallet_order_id");

  return (
    <div>
      <H1>Processing order...</H1>
      <P>
        Our partner Simplex is now processing you order... In the meanwhile
        please write down your order id.
      </P>

      <P>Order ID: {order_id}</P>
      <A href="https://www.simplex.com/support/">Any Issues? Get help.</A>
    </div>
  );
};

const H1 = styled.h1`
  font-size: 18px;
  color: #333333;
  padding-top: 30px;
  padding-left: 30px;
`;

const P = styled.p`
  padding-left: 30px;
  padding-right: 30px;
`;

const A = styled.a`
  padding-left: 30px;
  padding-right: 30px;
`;

export default Success;
